export type OfflineMsgType = 'CHAT'|'APP_COMM'

export enum OfflineMsgTypeAdv{
    CHAT = "0",
    APP_COMM = "1",
    ANON_CHAT = "2"
}